import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function OTP() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timeLeft, setTimeLeft] = useState(45);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    }
  }, [timeLeft]);
  const handleChange = (index: number, value: string) => {
    if (isNaN(Number(value))) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Auto-advance
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/feed');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-249">
      {/* Header */}
      <div className="px-4 py-6 flex items-center" data-id="element-250">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-white hover:bg-surface rounded-full transition-colors" data-id="element-251">
          <ArrowLeftIcon size={24} data-id="element-252" />
        </button>
      </div>

      <div className="flex-1 px-6 pb-6 flex flex-col" data-id="element-253">
        <div className="mb-8" data-id="element-254">
          <h1 className="text-3xl font-poppins font-bold text-white mb-2" data-id="element-255">
            Verify Phone
          </h1>
          <p className="text-softGray" data-id="element-256">
            We sent a 6-digit code to{' '}
            <span className="text-white font-medium" data-id="element-257">+1 (555) ***-**89</span>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col flex-1" data-id="element-258">
          <div className="flex justify-between gap-2 mb-8" data-id="element-259">
            {otp.map((digit, index) => <input key={index} ref={el => inputRefs.current[index] = el} type="text" inputMode="numeric" maxLength={1} value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className="w-12 h-14 bg-surface border border-border rounded-xl text-center text-2xl font-bold text-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors" data-id="element-260" />)}
          </div>

          <div className="text-center mb-auto" data-id="element-261">
            {timeLeft > 0 ? <p className="text-softGray text-sm" data-id="element-262">
                Resend code in{' '}
                <span className="text-primary font-medium" data-id="element-263">
                  0:{timeLeft.toString().padStart(2, '0')}
                </span>
              </p> : <button type="button" className="text-primary text-sm font-bold" data-id="element-264">
                Resend Code
              </button>}
          </div>

          <Button type="submit" className="mt-8" disabled={otp.some(d => d === '')} data-id="element-265">
            Verify & Continue
          </Button>
        </form>
      </div>
    </div>;
}